import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const scrapingApi = {
  /**
   * Trigger a scrape run. Omit `urls` to use the moderator's scraper-sources pool.
   * @param {{ urls?: string[]; max_pages?: number }} [body]
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  run: (body = {}, config) => mod.post('/scraping/run', body, config),

  /**
   * Poll current run state for this moderator.
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').ScrapingStatus>>}
   */
  getStatus: (config) => mod.get('/scraping/status', config),

  /**
   * Global scraping statistics (article counts, last run).
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').ScrapingStats>>}
   */
  getStats: (config) => mod.get('/scraping/stats', config),

  /**
   * Scrape history log.
   * @param {{ skip?: number; limit?: number }} [params]
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').ScrapingHistoryEntry[]>>}
   */
  getHistory: (params = {}, config = {}) =>
    mod.get('/scraping/history', { ...config, params }),

  /**
   * Purge old articles.
   * @param {{ days_old?: number; confirm?: boolean }} [params]
   */
  cleanup: (params = {}, config = {}) =>
    mod.post('/scraping/cleanup', null, { ...config, params }),
};
